import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronUp, faSignInAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { isWorkflowInput } from "@/components/Workflow/constants";
import { useWorkflowInstance } from "@/composables/useWorkflowInstance";
import { useInvocationStore } from "@/stores/invocationStore";
import LoadingSpan from "@/components/LoadingSpan.vue";
import WorkflowInvocationStep from "@/components/WorkflowInvocationState/WorkflowInvocationStep.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInvocationSteps',
    props: {
        storeId: null,
        invocation: null,
        isFullPage: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        library.add(faChevronDown, faChevronUp, faSignInAlt);
        const invocationStore = useInvocationStore();
        const { graphStepsByStoreId } = storeToRefs(invocationStore);
        const graphSteps = computed(() => graphStepsByStoreId.value[props.storeId]);
        const stepsDiv = ref();
        const { workflow, loading, error } = useWorkflowInstance(props.invocation.workflow_id);
        const workflowInputSteps = workflow.value
            ? Object.values(workflow.value.steps).filter((step) => isWorkflowInput(step.type))
            : [];
        const oneOrNoInput = computed(() => workflowInputSteps.length <= 1);
        const expandInvocationInputs = ref(oneOrNoInput.value);
        return { __sfc: true, props, invocationStore, graphStepsByStoreId, graphSteps, stepsDiv, workflow, loading, error, workflowInputSteps, oneOrNoInput, expandInvocationInputs, faChevronDown, faChevronUp, faSignInAlt, FontAwesomeIcon, BAlert, isWorkflowInput, LoadingSpan, WorkflowInvocationStep };
    }
});
